import { EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TerminalStoreService {
  onStoreChanged = new EventEmitter<number>();
  private _terminalStoreId: number;
  constructor() {}

  selectTerminalStoreId(storeId: number) {
    this._terminalStoreId = storeId;
    this.onStoreChanged.emit(storeId);
  }

  getTerminalStoreId(): number {
    return this._terminalStoreId;
  }

  get terminalStoreId() {
    return this._terminalStoreId;
  }
}
